// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktop":"yz_a","AdSlotBranding__mobile":"yz_b","AdSlotBranding--branding":"yz_c","body--branding":"yz_e","body--billboard":"yz_f"};